import ListingsRoutingResolver from './ListingRoutingResolver';

class IndividualsListingResolver extends ListingsRoutingResolver {

    constructor() {
        super()
        this.key = "individual"
    }
}

export default IndividualsListingResolver
